export default __webpack_public_path__ + "static/media/account.031a2277.svg";